import 'slick-carousel';
import 'slick-carousel/slick/slick.css';

$(function() {
    $('.hrg-ce-image .images-outer.images-outer-slider').slick({
        fade: true,
        prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><i class="fa-solid fa-arrow-left"></i></button>',
        nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><i class="fa-solid fa-arrow-right"></i></button>'
    });
});
